import { render, staticRenderFns } from "./RezervniDelovi.vue?vue&type=template&id=056e6fdd&scoped=true&"
import script from "./RezervniDelovi.vue?vue&type=script&lang=ts&"
export * from "./RezervniDelovi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e6fdd",
  null
  
)

export default component.exports